import { useDashboardListDispatch } from "../contexts/DashboardListContext";
import { useMarketplaceDispatch } from "../contexts/MarketplaceContext";
import { useDashboardCategoriesDispatch } from "../contexts/single-dashboard/DashboardCategoriesContext";

// payload: title, AccountId, UserId, description
export function useCreateDashboard() {

  async function createDashboard(payload) {
    const response = await fetch(`/api/dashboards`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      let data = await response.json();
      return data;
    }else{
      const errorData = await response.json()
      if(payload.newDashboardInfo.embedUrl){//only retrun the error msg for creating embed dash since only SA for creating embed dash is updated in POST api in stroty IW-3938
        return errorData
      }
      if (errorData?.reachedLimit) {
        return errorData;
      }
      console.error("Error creating dashboard:", response);
      return null
    }
  }
  return { createDashboard };
}
// should i separate the api call for published vs unpublished dashboards
export function useUpdateDashboard() {
  const dashboardDispatch = useDashboardListDispatch();
  const dashboardCatDispatch = useDashboardCategoriesDispatch();
  const marketplaceDispatch = useMarketplaceDispatch();

  async function updateDashboard(payload) {
    const res = await fetch(`/api/dashboards/${payload.id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
    if (res.ok)  {
      let data = await res.json();
      dashboardDispatch({type: 'updateDashboard', payload: data});
      // update context to include new dashboard template for accessing in marketplace
      if (payload.isPublishedToMarketplace) {
        marketplaceDispatch({ type: "addDashboardTemplate", payload: data})
        dashboardCatDispatch({type: "setDashCategories", payload: data})
      } else {
        // if just unpublished
        return data
      }
      return data
    } else {
      console.error("Error saving dashboard:", res.statusText)
      return res;
    }
  }
  return { updateDashboard };
}


//delete a dashboard, payload is the dashboard id
export function useDeleteDashboard() {
  const dashboardDispatch = useDashboardListDispatch();
  async function deleteDashboard(id) {
    const response = await fetch(`/api/dashboards/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (response.ok) {
      let data = await response.json();
      dashboardDispatch({ type: "removeDashboard", payload: data });
      return data;
    }
  }
  return deleteDashboard;
}

//delete a native dashboard, payload is the dashboard id
export function useDeleteNativeDashboard() {
  const dashboardDispatch = useDashboardListDispatch();
  async function deleteDashboard(id) {
    try {
      const response = await fetch(`/api/dashboards/native/${id}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (response.ok) {
        let data = await response.json();
        dashboardDispatch({ type: "removeDashboard", payload: data });
        return data;
      } else {
        // Handle non-ok responses
        console.error("Error deleting dashboard:", response.status, response.statusText);
        // Optionally dispatch an error action to update the UI
        return null; 
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Network error while deleting dashboard:", error);
      return null; 
    }
  }
  return deleteDashboard;
}


